var map = {
	"./Copy.vue": 67107,
	"./DownloadList.vue": 63168,
	"./Famous.vue": 84783,
	"./FamousInfo.vue": 97819,
	"./Floorplan.vue": 11475,
	"./History.vue": 74476,
	"./Index.vue": 33320,
	"./News.vue": 12341,
	"./NewsInfo.vue": 1413,
	"./NotFound.vue": 1825,
	"./SinglePage.vue": 52289,
	"./UserChangePassword.vue": 54838,
	"./UserEdit.vue": 21105,
	"./UserExhibition.vue": 78958,
	"./UserForgotPassword.vue": 65231,
	"./UserLogin.vue": 59452,
	"./UserLogout.vue": 88007,
	"./UserRegister.vue": 74774,
	"./UserReserve.vue": 94823,
	"./UserReserveInfo.vue": 54339,
	"./VueCropper - 副本.vue": 92179,
	"./VueCropper.vue": 68071,
	"./upload-cropper.vue": 63803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65522;